import React, { useEffect, useRef, useState } from 'react';
import { Check, Link as LinkIcon } from 'lucide-react';
import { Modal } from './';

interface ShareModalProps {
  isOpen: boolean;
  onClose: () => void;
  url: string;
  title: string;
}

const ShareModal: React.FC<ShareModalProps> = ({ isOpen, onClose, url, title }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (isOpen && inputRef.current) {
      inputRef.current.select();
      setCopied(false);
    }
  }, [isOpen]);

  const handleCopy = () => {
    if (inputRef.current) {
      inputRef.current.select();
      document.execCommand('copy'); // Note: clipboard API is cleaner but this is what was there
      setCopied(true);
      setTimeout(() => onClose(), 1500); 
    }
  };

  if (!isOpen) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={`Share ${title}`} zIndex={60}>
        <div className="space-y-4">
            <p className="text-sm text-slate-400">Copy the link below to share this {title.toLowerCase()}.</p>
            <div className="flex gap-2">
                <input 
                    ref={inputRef}
                    readOnly
                    value={url}
                    className="flex-grow p-2 border border-slate-600 rounded bg-slate-950 text-slate-200 text-sm font-mono"
                    onClick={(e) => (e.target as HTMLInputElement).select()}
                />
                <button 
                    onClick={handleCopy}
                    className={`px-4 py-2 rounded text-white font-bold transition-colors ${copied ? 'bg-emerald-600' : 'bg-fuchsia-600 hover:bg-fuchsia-700'}`}
                >
                    {copied ? <Check size={18} /> : <LinkIcon size={18} />}
                </button>
            </div>
        </div>
    </Modal>
  );
};

export default ShareModal;
